var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAttachment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    fillRule: "evenodd",
    stroke: "#111",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M7.888 20.215l12.25-12.25c.896-.895 2.388-.855 3.333.09.946.946.987 2.438.092 3.333L8.689 26.09c-1.72 1.72-4.585 1.642-6.4-.174C.471 24.1.393 21.234 2.112 19.514L16.941 4.686c2.588-2.588 6.903-2.47 9.636.264 2.734 2.734 2.852 7.048.264 9.635L14.483 26.944"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.59128878473fc48ab0acaf3dc8af761e.svg";
export { ForwardRef as ReactComponent };